import { Component, Input } from '@angular/core';
import { TranslationRequest } from '../../models/translation/translation-request';

@Component({
    selector: 'app-toast',
    template: `
    <div class="tw-flex">
      <div
        class="toast-container tw-grow-0 app-mb2 tw-flex"
        [ngClass]="toastClass"
        [style.margin-bottom]="disableMarginBottom ? 0 : 40"
        >
        @if (toastIcon) {
          <span class="left-border tw-justify-center">
            <mat-icon aria-hidden="true" tabindex="-1">{{ toastIcon }}</mat-icon>
          </span>
        }
    
        <div class="toast-text tw-grow">
          <!-- Support both message input and ng-content projection -->
          <ng-container *ngIf="message; else contentProjection">
            <span *ngIf="renderHtml" [innerHTML]="message | translation : translationRequest"></span>
            <span *ngIf="!renderHtml">{{ message | translation : translationRequest }}</span>
          </ng-container>
          <ng-template #contentProjection>
            <ng-content></ng-content>
          </ng-template>
        </div>
      </div>
    </div>
    `,
    styles: [
        `
      .toast-container {
        border-radius: 4px;
      }
      .toast-text {
        padding: 10px 10px 10px 0px;
        font-weight: bold;
        letter-spacing: 0.02rem;
      }
      .left-border {
        border-radius: 4px 0px 0px 4px;
        min-width: 40px;
        display: flex;
        align-items: center;
      }

      .toast-warning {
        color: var(--sed-engaged-black-color);
        background-color: var(--sed-status-yellow-color);
      }

      .toast-success {
        color: var(--sed-warm-white-color);
        background-color: var(--sed-status-green-color);
      }

      .toast-info {
        color: var(--sed-engaged-black-color);
        background-color: var(--sed-purple-40-color);
      }

      .toast-error {
        color: var(--sed-warm-white-color);
        background-color: var(--sed-status-red-color);
      }
    `,
    ],
    standalone: false
})
export class ToastComponent {
  @Input() type: ToastType;

  @Input() icon: string;

  @Input() disableMarginBottom: boolean;

  @Input() message: string;

  @Input() renderHtml: boolean = false;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  get toastClass(): string {
    switch (this.type) {
      case 'Error':
        return 'toast-error';
      case 'Success':
        return 'toast-success';
      case 'Info':
        return 'toast-info';
      case 'Warning':
        return 'toast-warning';
      default:
        return 'toast-info';
    }
  }

  get toastIcon(): string {
    if (this.icon) {
      return this.icon;
    }

    switch (this.type) {
      case 'Error':
        return 'cancel';
      case 'Success':
        return 'thumb_up';
      case 'Info':
        return 'info';
      case 'Warning':
        return 'warning';
      default:
        return 'info';
    }
  }
}

export type ToastType = 'Info' | 'Success' | 'Warning' | 'Error';
